import React, { Component } from 'react'
import { BrowserRouter, Routes, Route, NavLink, Navigate } from "react-router";
import './App.css'
import LoginDialog from './LoginDialog'
import API, {APIError} from './API'
import ProjectList from './Projects/List'
import ProjectEdit from './Projects/Edit'
import SettingsIcon from './Icons/Settings.svg'
import FoldersIcon from './Icons/Folders.svg'
import WebSettingsIcon from './Icons/WebSettings.svg'
import WebList from './Web/List';
import WebEdit from './Web/Edit';

export let Instance
class App extends Component {
  constructor(props) {
    super(props)
	window.App = this
	Instance = this
    this.state = {
		Modals: [],
		Token: localStorage.getItem('Token'),
    }
    this.Refresh()
    setInterval(()=>this.Refresh(),3000)
    fetch('/ui/ServerInfo').then(r=>r.json()).then(ServerInfo=>this.setState({ServerInfo: ServerInfo}))
	const query = new URLSearchParams(window.location.search)
	if (query.get('folder')) {
		const folder = query.get('folder')
		setInterval(()=>{
			if (this.state.Token)
				API('IDE').then(async Response=>{
					if (Response?.Token) {
						window.cookies.set('vscode-tkn', Response.Token, { path: '/' })
						const test = await fetch('/?folder=' + query.get('folder')).catch(e=>null)
						if (test?.status == 200) {
							window.location.href = '/?folder=' + query.get('folder')
						} else {
							setTimeout(()=>this.Refresh(),2000)
						}
					}
				})
		}, 1000)
	}
  }
  async Refresh() {
	if (localStorage.getItem('Token') != this.state.Token) {
	    this.setState({
    	  Token: localStorage.getItem('Token'),
	    })
	}
	if (this.state.Token) {
		const Info = await API('Info')
		if (Info && !Info.Error) {
			this.setState({
				Info: Info,
			})
		}
	}
  }
  Popup(Popup) {
	this.setState({Popup:Popup})
  }
  LogOut() {
    localStorage.removeItem('DeviceSecret')
    localStorage.removeItem('Token')
    this.setState({
      Info: false,
      Token: false,
    })
    window.location.reload()
  }
  render() {
    window.document.title = this.state.ServerInfo?.ServerName||this.state.ServerInfo?.ServerHost||"Development Server"
    if (this.state.Token) {
		return (
			<>
				{this.state.Info?.Status?(
					<div class="Banner">
						<div>{this.state.Info.Status}</div>
					</div>
				):(
					<></>
				)}
				{this.state.Error?(
					<div class="Error Banner">
						<button onClick={()=>this.setState({Error: false})}>X</button>
						<div>{this.state.Error}</div>
					</div>
				):(
					<></>
				)}
				<div className="App" >
					<BrowserRouter>
						<div class="Toolbar">
							<NavLink to="/ui/project"><img class="Icon" src={FoldersIcon} /></NavLink>
							<NavLink to="/ui/web"><img class="Icon" src={WebSettingsIcon} /></NavLink>
							<NavLink to="/ui/settings" className="Right"><img class="Icon" src={SettingsIcon} /></NavLink>
						</div>
						{this.state.Info?(
						<Routes>
							<Route path="*" element={<Navigate to="/ui/project" replace={true} />} />
							<Route path="/ui/settings" element={<div>Settings</div>} />
							<Route path="/ui/web" element={<WebList />} />
							<Route path="/ui/web/:Hostname" element={<WebEdit />} />
							<Route path="/ui/project" element={<ProjectList />} />
							<Route path="/ui/project/:Name" element={<ProjectEdit />} />
						</Routes>
						):(<div class="Loading">Loading...</div>)}
					</BrowserRouter>
				</div>
				{this.state.Popup?(
					<div class="Popup">
						<button onClick={()=>this.setState({Popup: false})}>X</button>
						<div>{this.state.Popup}</div>
					</div>
				):(
					<></>
				)}
			</>
		)
    }
    return (
		<div className="App" >
			<LoginDialog onLogin={()=>this.Refresh()} />
		</div>
    )
  }
}

export default App